import Vue from 'vue'
import lodashGet from 'lodash.get'
import VueRouter from 'vue-router'
import { orderRoutes } from './order'
import goodsRoutes from './goods'
import eventRoutes from './event'
import myGoldRoutes from './my_gold'
import missionCenterRoutes from './mission_center'
import lessonExchangeRoutes from './lesson_exchange'
import eyesProtectGuide from './eyes_protect_guide'
import mall from './mall'
import comment from './comment'
import childrensSong from './childrens_song'
import digitalLibraryRoutes from './digital_library'
import { mycouponRoutes } from './mycoupon'
import { landingRoutes } from './landing'
import wx from './wx'
import guideRoutes from './guide'
import wxjssdk from '@/common/wxjssdk'
import * as LandingParamsHanlder from '@/common/landingparams'
console.log('LandingParamsHanlder', LandingParamsHanlder)

Vue.use(VueRouter)

const createOrderGuard = (router, defaultTitle) => {
  // const defaultTitle=window.document.title
  router.afterEach((to, from) => {
    const $index = to.matched.findIndex((item) => {
      return lodashGet(item, 'meta.title', false)
    })
    if ($index === -1) {
      window.document.title = defaultTitle
      return
    }
    const title = to.matched[$index].meta.title
    window.document.title = title
  })
}

const routes = [
  {
    path: '/practical_english',
    component: () => import('../views/page/practical_english/index.vue')
  },
  {
    path: '/test',
    component: () => import('../views/page/test.vue')
  },
  {
    path: '/cr/:reportId',
    component: () => import('../views/page/cr.vue')
  },
  {
    path: '/edit_profile',
    component: () => import('../views/page/user/edit_profile.vue')
  },
  {
    path: '/login',
    component: () => import('../views/page/login.vue')
  },
  {
    path: '/user_agreement',
    component: () => import('../views/page/user_agreement.vue'),
    meta: {
      title: 'VIPKID用户中心服务协议'
    }
  },
  {
    path: '/privacy_agreement',
    component: () => import('../views/page/privacy_agreement.vue')
  },
  {
    path: '/refund_agreement_2020_11',
    component: () => import('../views/page/refund_agreement_2020_11.vue')
  },
  {
    path: '/refund_agreement_2020_12',
    component: () => import('../views/page/refund_agreement_2020_12.vue')
  },
  {
    path: '/refund_agreement',
    component: () => import('../views/page/refund_agreement.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/page/home.vue')
  },
  {
    path: '/home_xiaoai',
    name: 'home',
    component: () => import('../views/page/home_xiaoai.vue')
  },
  {
    path: '/emoji',
    name: 'emoji',
    component: () => import('../views/page/home/emoji.vue')
  },
  {
    path: '/how_to_learning',
    component: () => import('../views/page/how_to_learning.vue')
  },
  {
    path: '/our_features',
    component: () => import('../views/page/home/our_features.vue')
  },
  {
    path: '/brand_info',
    component: () => import('../views/page/home/brand_info.vue')
  },
  {
    path: '/my_teacher',
    component: () => import('../views/page/my_teacher.vue')
  },
  {
    path: '/wx81274c4d224d9151',
    component: () => import('../views/page/uninstalled.vue')
  },
  {
    path: '/product_agree',
    component: () => import('../views/page/product_agree/index.vue')
  },
  ...orderRoutes,
  ...goodsRoutes,
  ...mycouponRoutes,
  ...wx,
  ...eventRoutes,
  ...lessonExchangeRoutes,
  ...landingRoutes,
  ...myGoldRoutes,
  ...guideRoutes,
  ...mall,
  ...digitalLibraryRoutes,
  ...missionCenterRoutes,
  ...childrensSong,
  ...eyesProtectGuide,
  ...comment
]

const router = new VueRouter({
  mode: 'history',
  base: '/web' || process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, saveTop) { // 跳转后默认回到页面顶部
    if (saveTop) {
      return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 刷新微信jssdk配置
router.afterEach((to, from) => {
  wxjssdk.init()
  wxjssdk.updateShareData({
    title: 'VIPKID启蒙英语',
    desc: '让4-6岁孩子爱学敢说', // 分享描述
    link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'https://img.vipkidstatic.com/cls/nezha/img/8BCB8118-A6CC-4F3C-8AF0-736D22739E55.png' // 分享图标
  })
})
/**
 * delete by guochao
 * 和下面的钩子重叠
router.beforeEach((to, from, next) => {
  const fromChannelId = lodashGet(from, 'query.channel_id', false)
  const toChannleId = lodashGet(to, 'query.channel_id', false)
  if (fromChannelId && !toChannleId) {
    to.query.channel_id = from.query.channel_id
    next(to)
  } else {
    next()
  }
})
 */

router.beforeEach((to, from, next) => {
  // 商品详情页、轻课详情页缓存query参数
  if (['goods.webdetail', 'goods.discountWebDetail'].indexOf(to.name) !== -1) {
    LandingParamsHanlder.initDefaultParams(to.query)
    return next()
  }

  const landingParams = LandingParamsHanlder.getDefaultParams()
  // 这里不包括success2(success2属于社群单独页面)
  if (['order.create', 'order.create2', 'order.success', 'order.repay'].indexOf(to.name) === -1) {
    return next()
  }

  // 如果参数一致
  if (LandingParamsHanlder.compareParams(to.query, landingParams)) {
    return next()
  }
  Object.assign(to.query, landingParams)
  return next(to)
})

createOrderGuard(router, window.document.title)

export default router
